module.exports = __webpack_public_path__ + "static/media/15.d038e036.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/hats/15.png
// module id = 1297
// module chunks = 0